import { CartCategory, Product, ProductImageType, ProductType } from '../../context/CartContext';
import cannedSodaImage from '../../assets/images/storefront/product_storefront_canned_soda.svg';
import chipsImage from '../../assets/images/storefront/product_storefront_chips.svg';
import energyDrinkImage from '../../assets/images/storefront/product_storefront_energy_drink.svg';
import takisImage from '../../assets/images/storefront/product_storefront_takis.svg';
import keychainArtDogImage from '../../assets/images/storefront/keychain_art_dog.png';
import keychainArtSharkImage from '../../assets/images/storefront/keychain_art_shark.png';
import keychainArtPigImage from '../../assets/images/storefront/keychain_art_pig.png';
import clickerKeychainDogImage from '../../assets/images/storefront/clicker_keychain_dog.png';
import clickerKeychainCatImage from '../../assets/images/storefront/clicker_keychain_cat.png';
import articulatedFrogImage from '../../assets/images/storefront/art_frog_large.png';
import stickerFayettevilleImage from '../../assets/images/storefront/sticker_fayetteville.png';
import stickerGulleyParkImage from '../../assets/images/storefront/sticker_gulley_park.png';

export const storeFrontProducts: Product[] = [
  {
    id: '7000',
    name: 'Canned Soda',
    price: 2,
    wholesale_price: 1,
    height_inches: 4.8,
    width_inches: 2.6,
    depth_inches: 2.6,
    images: [
      { image_path: cannedSodaImage, image_type: ProductImageType.DETAIL },
      { image_path: cannedSodaImage, image_type: ProductImageType.SMALL },
      { image_path: cannedSodaImage, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 370,
    product_type: ProductType.StoreFront,
    cart_category: CartCategory.LOCAL_PICKUP_ONLY,
    category: 'Drinks',
    sub_category: 'Soda',
    description: 'A cold canned soda.',
    is_customizeable: false,
    enabled: true
  },
  {
    id: '7001',
    name: 'Chips',
    price: 2,
    wholesale_price: 1,
    height_inches: 8,
    width_inches: 5,
    depth_inches: 2,
    images: [
      { image_path: chipsImage, image_type: ProductImageType.DETAIL },
      { image_path: chipsImage, image_type: ProductImageType.SMALL },
      { image_path: chipsImage, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 50,
    product_type: ProductType.StoreFront,
    cart_category: CartCategory.LOCAL_PICKUP_ONLY,
    category: 'Snacks',
    sub_category: 'Chips',
    description: 'A single bag of chips.',
    is_customizeable: false,
    enabled: true
  },
  {
    id: '7002',
    name: 'Energy Drink',
    price: 3,
    wholesale_price: 2,
    height_inches: 6.2,
    width_inches: 2.4,
    depth_inches: 2.4,
    images: [
      { image_path: energyDrinkImage, image_type: ProductImageType.DETAIL },
      { image_path: energyDrinkImage, image_type: ProductImageType.SMALL },
      { image_path: energyDrinkImage, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 475,
    product_type: ProductType.StoreFront,
    cart_category: CartCategory.LOCAL_PICKUP_ONLY,
    category: 'Drinks',
    sub_category: 'Energy Drinks',
    description: 'A chilled energy drink.',
    is_customizeable: false,
    enabled: true
  },
  {
    id: '7003',
    name: 'Takis',
    price: 1,
    wholesale_price: 0.5,
    height_inches: 7,
    width_inches: 4.5,
    depth_inches: 1.5,
    images: [
      { image_path: takisImage, image_type: ProductImageType.DETAIL },
      { image_path: takisImage, image_type: ProductImageType.SMALL },
      { image_path: takisImage, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 45,
    product_type: ProductType.StoreFront,
    cart_category: CartCategory.LOCAL_PICKUP_ONLY,
    category: 'Snacks',
    sub_category: 'Takis',
    description: 'A single bag of Takis.',
    is_customizeable: false,
    enabled: true
  },
  {
    id: '7004',
    name: 'Articulated Dog Keychain',
    price: 5,
    wholesale_price: 2,
    height_inches: 3.5,
    width_inches: 1.2,
    depth_inches: 0.8,
    images: [
      { image_path: keychainArtDogImage, image_type: ProductImageType.DETAIL },
      { image_path: keychainArtDogImage, image_type: ProductImageType.SMALL },
      { image_path: keychainArtDogImage, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 20,
    product_type: ProductType.StoreFront,
    cart_category: CartCategory.LOCAL_PICKUP_ONLY,
    category: 'Articulated Keychains',
    sub_category: 'Animals',
    description: 'A flexible 3D printed dog keychain with segmented joints and a swivel clasp.',
    is_customizeable: false,
    enabled: true
  },
  {
    id: '7005',
    name: 'Articulated Shark Keychain',
    price: 5,
    wholesale_price: 2,
    height_inches: 3.5,
    width_inches: 1.1,
    depth_inches: 0.8,
    images: [
      { image_path: keychainArtSharkImage, image_type: ProductImageType.DETAIL },
      { image_path: keychainArtSharkImage, image_type: ProductImageType.SMALL },
      { image_path: keychainArtSharkImage, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 20,
    product_type: ProductType.StoreFront,
    cart_category: CartCategory.LOCAL_PICKUP_ONLY,
    category: 'Articulated Keychains',
    sub_category: 'Animals',
    description: 'A flexible 3D printed shark keychain with articulated body sections and a swivel clasp.',
    is_customizeable: false,
    enabled: true
  },
  {
    id: '7006',
    name: 'Articulated Pig Keychain',
    price: 5,
    wholesale_price: 2,
    height_inches: 3.5,
    width_inches: 1.2,
    depth_inches: 0.8,
    images: [
      { image_path: keychainArtPigImage, image_type: ProductImageType.DETAIL },
      { image_path: keychainArtPigImage, image_type: ProductImageType.SMALL },
      { image_path: keychainArtPigImage, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 20,
    product_type: ProductType.StoreFront,
    cart_category: CartCategory.LOCAL_PICKUP_ONLY,
    category: 'Articulated Keychains',
    sub_category: 'Animals',
    description: 'A flexible 3D printed pig keychain with segmented joints and a swivel clasp.',
    is_customizeable: false,
    enabled: true
  },
  {
    id: '7007',
    name: 'Dog Clicker Keychain',
    price: 5,
    wholesale_price: 2,
    height_inches: 2.5,
    width_inches: 2,
    depth_inches: 0.8,
    images: [
      { image_path: clickerKeychainDogImage, image_type: ProductImageType.DETAIL },
      { image_path: clickerKeychainDogImage, image_type: ProductImageType.SMALL },
      { image_path: clickerKeychainDogImage, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 25,
    product_type: ProductType.StoreFront,
    cart_category: CartCategory.LOCAL_PICKUP_ONLY,
    category: 'Clicker Keychains',
    sub_category: 'Animals',
    description: 'A dog-themed clicker keychain with a smiling golden retriever design and swivel clasp.',
    is_customizeable: false,
    enabled: true
  },
  {
    id: '7008',
    name: 'Cat Clicker Keychain',
    price: 5,
    wholesale_price: 2,
    height_inches: 2.4,
    width_inches: 2,
    depth_inches: 0.8,
    images: [
      { image_path: clickerKeychainCatImage, image_type: ProductImageType.DETAIL },
      { image_path: clickerKeychainCatImage, image_type: ProductImageType.SMALL },
      { image_path: clickerKeychainCatImage, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 25,
    product_type: ProductType.StoreFront,
    cart_category: CartCategory.LOCAL_PICKUP_ONLY,
    category: 'Clicker Keychains',
    sub_category: 'Animals',
    description: 'A cat-themed clicker keychain with a surprised tabby face design and swivel clasp.',
    is_customizeable: false,
    enabled: true
  },
  {
    id: '7009',
    name: 'Articulated Frog',
    price: 7,
    wholesale_price: 2,
    height_inches: 1.2,
    width_inches: 3.2,
    depth_inches: 2.8,
    images: [
      { image_path: articulatedFrogImage, image_type: ProductImageType.DETAIL },
      { image_path: articulatedFrogImage, image_type: ProductImageType.SMALL },
      { image_path: articulatedFrogImage, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 25,
    product_type: ProductType.StoreFront,
    cart_category: CartCategory.LOCAL_PICKUP_ONLY,
    category: 'Articulated Figures',
    sub_category: 'Animals',
    description: 'A bright green 3D printed articulated frog with flexible legs and playful details.',
    is_customizeable: false,
    enabled: true
  },
  {
    id: '7010',
    name: 'Fayetteville Arkansas Sticker',
    price: 2,
    wholesale_price: 1,
    height_inches: 3,
    width_inches: 3,
    depth_inches: 0.1,
    images: [
      { image_path: stickerFayettevilleImage, image_type: ProductImageType.DETAIL },
      { image_path: stickerFayettevilleImage, image_type: ProductImageType.SMALL },
      { image_path: stickerFayettevilleImage, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 5,
    product_type: ProductType.StoreFront,
    cart_category: CartCategory.LOCAL_PICKUP_ONLY,
    category: 'Stickers',
    sub_category: 'Local',
    description: 'A red and black Fayetteville Arkansas sticker with bold circular lettering.',
    is_customizeable: false,
    enabled: true
  },
  {
    id: '7011',
    name: 'Gulley Park Sticker',
    price: 2,
    wholesale_price: 1,
    height_inches: 2.5,
    width_inches: 4,
    depth_inches: 0.1,
    images: [
      { image_path: stickerGulleyParkImage, image_type: ProductImageType.DETAIL },
      { image_path: stickerGulleyParkImage, image_type: ProductImageType.SMALL },
      { image_path: stickerGulleyParkImage, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 5,
    product_type: ProductType.StoreFront,
    cart_category: CartCategory.LOCAL_PICKUP_ONLY,
    category: 'Stickers',
    sub_category: 'Local',
    description: 'A Gulley Park sticker with large green lettering and a dark outline.',
    is_customizeable: false,
    enabled: true
  }
];
